import validate from "/builds/macys/polaris/nuxt-app/registry-ui/node_modules/nuxt/dist/pages/runtime/validate.js";
import meta_45global from "/builds/macys/polaris/nuxt-app/registry-ui/app/middleware/meta.global.js";
import manifest_45route_45rule from "/builds/macys/polaris/nuxt-app/registry-ui/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  meta_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}